import Notifications, { notes } from "@phoenixreisen/mithrils/src/notification";
import FormWrapper from "../components/formular/form.wrapper.m";
import SideNav from "../../shared/header/navigation.extern.m";
import ShortNav from "../../shared/header/navigation.short.m";
import Separator from "../components/separator/separator.m";
import Footer from "@phoenixreisen/mithrils/src/footer";
import Header from "../../shared/header/header.m";
import m from "mithril";
const Page = {
    view: () => {
        return [
            m(Header, { noNav: false, SideNav: SideNav, ShortNav: ShortNav, headline: "Phoenix Katalog", version: "Phoenix Reisen - Kataloge", type: "extern" }),
            m(FormWrapper, null),
            m(Separator, null),
            m(Footer, null),
            m(Notifications, { list: notes }),
        ];
    },
};
export default Page;
